module.exports = __webpack_public_path__ + "static/media/quest.2063e479.png";